<template>
  <div class="bot-login-page">
    <div class="bot-login-card">
      <div class="bot-login-card__logo">H</div>
      <div class="bot-login-card__title">Hoo-ly</div>
      <div class="bot-login-card__status">Завантаження...</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "LoginPage",
  mounted() {
    var token = this.$route.params.id;
    if (token !== null && token !== undefined) {
      this.$store.dispatch("botLogin", token);
      if (this.$route.params.page)
        this.$router.push({ name: this.$route.params.page });
      else this.$router.push({ path: "/bot" });
    }
  },
};
</script>

<style scoped>
.bot-login-page {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  background: #f4f7fb;
}

.bot-login-card {
  width: min(100%, 320px);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  padding: 24px;
  border: 1px solid #e4eaf2;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 18px 46px rgba(15, 38, 65, 0.14);
}

.bot-login-card__logo {
  width: 46px;
  height: 46px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  color: #ffffff;
  background: #173b5d;
  font-size: 1.2rem;
  font-weight: 900;
}

.bot-login-card__title {
  color: #173b5d;
  font-size: 1.1rem;
  font-weight: 900;
}

.bot-login-card__status {
  color: #526171;
  font-size: 0.82rem;
  font-weight: 700;
}
</style>
